// Use settings from window.theThreadSettings if available
const blogSection = document.getElementById('blog-article-section');
const initialCount = parseInt(blogSection.dataset.initialCount, 10) || 9;
const loadMoreCount = parseInt(blogSection.dataset.loadMoreCount, 10) || 9;
const cards = Array.from(document.querySelectorAll('.blog-card-js'));
const loadMoreBtn = document.getElementById('load-more-blogs');
let visibleCount = initialCount;

function updateVisibility() {
  for (let idx = 0; idx < cards.length; idx++) {
    const cardElem = cards[idx];
    if (idx < visibleCount) {
      cardElem.style.display = '';
    } else {
      cardElem.style.display = 'none';
    }
  }
  if (visibleCount >= cards.length) {
    loadMoreBtn.style.display = 'none';
  } else {
    loadMoreBtn.style.display = '';
  }
}

function showNext() {
  visibleCount += loadMoreCount;
  updateVisibility();
}

updateVisibility();

if (loadMoreBtn) {
  loadMoreBtn.addEventListener('click', function (e) {
    e.preventDefault();
    showNext();
  });
}
